import { occupiedMinutes } from './slotOccupancy';

export const SlotBlockReason = {
  none: 'none',
  bayFull: 'bayFull',
  vehicleBooked: 'vehicleBooked',
  mechanicBooked: 'mechanicBooked',
};

function parseTime(value) {
  const [hourPart, minutePart] = String(value || '09:00').slice(0, 5).split(':');
  return {
    hour: Number(hourPart) || 9,
    minute: Number(minutePart) || 0,
  };
}

function windowOverlaps(window, otherStart, otherMinutes) {
  const otherEnd = new Date(otherStart.getTime() + otherMinutes * 60_000);
  const windowEnd = new Date(window.start.getTime() + window.minutes * 60_000);
  return window.start < otherEnd && windowEnd > otherStart;
}

export function evaluateSlots({
  day,
  hours,
  intervalMinutes,
  durationMinutes,
  parallelSlots,
  busy,
  mechanicId,
  vehicleId,
  ignoreBookingId,
}) {
  if (!hours || hours.is_closed || durationMinutes <= 0) return [];

  const opens = parseTime(hours.opens_at);
  const closes = parseTime(hours.closes_at);
  const open = new Date(
    day.getFullYear(),
    day.getMonth(),
    day.getDate(),
    opens.hour,
    opens.minute
  );
  const close = new Date(
    day.getFullYear(),
    day.getMonth(),
    day.getDate(),
    closes.hour,
    closes.minute
  );
  if (close <= open) return [];

  const interval = intervalMinutes < 15 ? 15 : intervalMinutes;
  const span = occupiedMinutes(durationMinutes, interval);
  const bays = Math.min(2, Math.max(1, parallelSlots || 1));
  const options = [];
  const now = new Date();
  let cursor = new Date(open);

  while (new Date(cursor.getTime() + span * 60_000) <= close) {
    const slotStart = new Date(cursor);
    if (slotStart >= now) {
      const relevant = busy.filter((window) => {
        const ignored = ignoreBookingId && window.bookingId === ignoreBookingId;
        return !ignored && windowOverlaps(window, slotStart, span);
      });
      const bayTaken = relevant.length >= bays;
      const mechanicTaken =
        mechanicId && relevant.some((window) => window.mechanicId === mechanicId);
      const vehicleTaken =
        vehicleId &&
        relevant.some(
          (window) =>
            window.vehicleId === vehicleId &&
            window.start.getFullYear() === day.getFullYear() &&
            window.start.getMonth() === day.getMonth() &&
            window.start.getDate() === day.getDate()
        );

      let reason = SlotBlockReason.none;
      if (bayTaken || mechanicTaken || vehicleTaken) {
        reason = vehicleTaken
          ? SlotBlockReason.vehicleBooked
          : mechanicTaken
            ? SlotBlockReason.mechanicBooked
            : SlotBlockReason.bayFull;
      }

      options.push({
        start: slotStart,
        reason,
        isAvailable: reason === SlotBlockReason.none,
      });
    }
    cursor = new Date(cursor.getTime() + interval * 60_000);
  }

  return options;
}
